import { useMemo } from 'react';

export const SEARCH_SECTIONS = {
  BUY: /^\/(sale)\/flat\/(\d+)\/?/,
  RENT: /^\/(rent)\/flat\/(\d+)\/?/,
} as const;

export type SearchSectionType = 'buy' | 'rent' | 'any';

export function useIsSearchPage(section: SearchSectionType = 'any'): boolean {
  const isSearchPage = useMemo(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    const searchSectionMap: Record<SearchSectionType, Array<RegExp | string>> = {
      buy: [SEARCH_SECTIONS.BUY],
      rent: [SEARCH_SECTIONS.RENT],
      any: [SEARCH_SECTIONS.BUY, SEARCH_SECTIONS.RENT],
    };

    const rulesToCheck = searchSectionMap[section];

    return rulesToCheck.some(rule => {
      if (typeof rule === 'string') {
        return location.pathname === rule;
      }

      return rule.test(location.pathname);
    });
  }, [section]);

  return isSearchPage;
}
